<template>
  <material-card
    scrollable
    :title="$t('components.plancreationwizard.coverage_configuration')"
    :color="$vuetify.theme.themes.light.secondary"
    icon="settings_applications"
  >
    <v-dialog scrollable v-model="dialogs.edit" persistent max-width="1100">
      <material-card
        :title="$t(coverageParameterFormTitle)"
        :icon="coverageParameterFormIcon"
        :color="formColor"
      >
        <v-card-text v-if="dialogs.edit && item">
          <v-form ref="form" v-model="valid">
            <v-container fluid fill-height>
              <v-row wrap>
                <v-col xs="12" sm="6" md="4" lg="3">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-container pa-0>
                        <v-row no-gutters>
                          <v-col>
                            <trans-textbox
                              v-model="item.ConfigurationParameter"
                              :label="$t('globals.name')"
                              :rules="[
                                $rules.required,
                                rules.uniqueParameterName,
                                (str) => {
                                  let exp = /^([a-zA-Z_]+).*$/gim;
                                  return (
                                    exp.test(str) ||
                                    $t(
                                      'components.plancreationwizard.coverage_configuration_parameters.Name must start with a letter or underscore'
                                    )
                                  );
                                },
                                (str) => {
                                  let exp =
                                    /^(?!(abs|acos|asin|atan|ceiling|cos|exp|floor|ieeeRemainder|if|in|log|log10|max|min|pow|round|sign|sin|sqrt|tan|truncate)$).*$/gim;
                                  return (
                                    exp.test(str) ||
                                    $t(
                                      'components.plancreationwizard.coverage_configuration_parameters.Name must not be a special name'
                                    )
                                  );
                                },
                              ]"
                              class="required"
                              field="Name"
                              :dialog="dialogs.edit"
                            ></trans-textbox>
                          </v-col>
                          <v-col
                            style="margin-top: 20px; margin-left: 3px"
                            cols="auto"
                          >
                            <v-icon v-bind="attrs" v-on="on">help</v-icon>
                          </v-col>
                        </v-row>
                      </v-container>
                    </template>
                    <span>
                      {{
                        $t(
                          "components.plancreationwizard.parameter_name_tooltip"
                        )
                      }}
                    </span>
                  </v-tooltip>
                </v-col>
                <v-col xs="12" sm="6" md="4" lg="3">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-container pa-0>
                        <v-row no-gutters>
                          <v-col>
                            <!-- <auto-select
                              :value.sync="
                                item.ConfigurationParameter.ParameterType
                              "
                              :items="options.Enums.ParameterType"
                              :label="
                                $t(
                                  'components.plancreationwizard.parameter_type'
                                )
                              "
                              :rules="[$rules.required]"
                              class="required"
                              :slots="true"
                              :filter="filterFunc"
                              :return-object="false"
                            >
                              <template v-slot:selection="data">
                                {{ $t("enums." + data.item) }}
                              </template>
                              <template v-slot:item="data">
                                <v-list-item-content
                                  v-text="$t('enums.' + data.item)"
                                ></v-list-item-content>
                              </template>
                            </auto-select> -->
                            <trans-enum
                              :value.sync="
                                item.ConfigurationParameter.ParameterType
                              "
                              :items="options.Enums.ParameterType"
                              :label="
                                $t(
                                  'components.plancreationwizard.parameter_type'
                                )
                              "
                              :rules="[$rules.required]"
                              class="required"
                            ></trans-enum>
                          </v-col>
                          <v-col
                            style="margin-top: 20px; margin-left: 3px"
                            cols="auto"
                          >
                            <v-icon v-bind="attrs" v-on="on">help</v-icon>
                          </v-col>
                        </v-row>
                      </v-container>
                    </template>
                    <span>
                      {{
                        $t(
                          "components.plancreationwizard.parameter_type_tooltip"
                        )
                      }}
                    </span>
                  </v-tooltip>
                </v-col>
                <v-col
                  xs="12"
                  sm="6"
                  md="4"
                  lg="3"
                  v-if="
                    item.ConfigurationParameter.ParameterType === 'Constant'
                  "
                >
                  <auto-select
                    :value.sync="item.ConfigurationParameter.Type"
                    :label="$t('components.plancreationwizard.system_type')"
                    :rules="[$rules.required]"
                    class="required"
                    :items="systemTypes"
                    item-value="Id"
                    item-text="Name"
                    :returnObject="false"
                  ></auto-select>
                </v-col>
                <v-col xs="12" sm="6" md="4" lg="3">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-container pa-0>
                        <v-row no-gutters>
                          <v-col>
                            <!-- <auto-select
                              :value.sync="
                                item.ConfigurationParameter.UsedInFormulaType
                              "
                              :items="formulaTypes"
                              :label="
                                $t('components.plancreationwizard.applies_on')
                              "
                              :rules="[$rules.required]"
                              class="required"
                              :slots="true"
                              :filter="filterFunc"
                              :returnObject="false"
                            >
                              <template v-slot:selection="data">
                                {{ $t("enums." + data.item) }}
                              </template>
                              <template v-slot:item="data">
                                <v-list-item-content
                                  v-text="$t('enums.' + data.item)"
                                ></v-list-item-content>
                              </template>
                            </auto-select> -->
                            <trans-enum
                              :value.sync="
                                item.ConfigurationParameter.UsedInFormulaType
                              "
                              :items="formulaTypes"
                              :label="
                                $t('components.plancreationwizard.applies_on')
                              "
                              :rules="[$rules.required]"
                              class="required"
                            ></trans-enum>
                          </v-col>
                          <v-col
                            style="margin-top: 20px; margin-left: 3px"
                            cols="auto"
                          >
                            <v-icon v-bind="attrs" v-on="on">help</v-icon>
                          </v-col>
                        </v-row>
                      </v-container>
                    </template>
                    <span>
                      {{
                        $t(
                          "components.plancreationwizard.parameter_applies_on_tooltip"
                        )
                      }}
                    </span>
                  </v-tooltip>
                </v-col>
                <v-col
                  v-if="
                    item.ConfigurationParameter.UsedInFormulaType == 'AdminFee'
                  "
                >
                  <v-checkbox
                    :label="$t('components.plancreationwizard.on_coverage')"
                    v-model="adminFeeOnCoverage"
                  ></v-checkbox>
                </v-col>
                <template v-if="adminFeeOnCoverage || coverageVisible">
                  <v-col xs="12" sm="6" md="4" lg="3">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-container pa-0>
                          <v-row no-gutters>
                            <v-col>
                              <v-autocomplete
                                v-model="item.ConfigurationParameter.Coverage"
                                :items="filteredCoverage()"
                                :label="$t('globals.coverage')"
                                :rules="[$rules.required]"
                                class="required"
                                :item-text="
                                  (item) =>
                                    `${trans(item, 'Name')} (${truncate(
                                      trans(item, 'Description'),
                                      40
                                    )})`
                                "
                                item-value="Identifier"
                                return-object
                              ></v-autocomplete>
                            </v-col>
                            <v-col
                              style="margin-top: 20px; margin-left: 3px"
                              cols="auto"
                            >
                              <v-icon v-bind="attrs" v-on="on">help</v-icon>
                            </v-col>
                          </v-row>
                        </v-container>
                      </template>
                      <span>
                        {{
                          $t(
                            "components.plancreationwizard.parameter_coverage_tooltip"
                          )
                        }}
                      </span>
                    </v-tooltip>
                  </v-col>
                  <v-col
                    xs="12"
                    sm="6"
                    md="4"
                    lg="3"
                    v-if="
                      item.ConfigurationParameter.Coverage !== null &&
                      item.ConfigurationParameter.Coverage !== undefined &&
                      item.ConfigurationParameter.Coverage.HasCoverageChoice
                    "
                  >
                    <trans-select2
                      v-model="item.ConfigurationParameter"
                      propertyName="CoverageStatus"
                      field="Name"
                      :items="options.Models.FamilyStatus"
                      itemValue="Id"
                      :label="$t('components.addmemberwizard.coverage_status')"
                    ></trans-select2>
                  </v-col>
                </template>
                <v-col
                  xs="12"
                  sm="6"
                  md="4"
                  lg="3"
                  v-else-if="contributionCategoriesVisible"
                >
                  <!-- <v-autocomplete
    :clearable="true"
    v-model="item.ConfigurationParameter.ContributionCategory"
    clear-icon="clear"
    :label="
                      $t(
                        'components.plancreationwizard.contribution_categories'
                      )
                    "
                    :rules="[$rules.required]"
                    class="required"
    :items="contributionCategories"
    item-value="Identifier"
                    item-text="Category"
                    :auto-select-first="true"
  ></v-autocomplete> -->
                  <auto-select
                    :value.sync="item.ContributionCategory"
                    :items="contributionCategories"
                    :label="
                      $t('components.plancreationwizard.contribution_category')
                    "
                    :rules="[$rules.required]"
                    class="required"
                    item-value="Identifier"
                    item-text="Category"
                  >
                    <!-- <template v-slot:selection="data">
                                {{ data.item.Category }}
                              </template>
                              <template v-slot:item="data">
                                <v-list-item-content
                                  v-text="data.item.Category"
                                ></v-list-item-content>
                              </template> -->
                  </auto-select>
                </v-col>
                <v-col
                  xs="12"
                  sm="6"
                  md="4"
                  lg="3"
                  v-else-if="employersVisible"
                >
                  <trans-select2
                    v-model="item.ConfigurationParameter.Identity"
                    propertyName="Employer"
                    :items="employers"
                    :label="$t('headers.members_management.Employer')"
                    :rules="[$rules.required]"
                    class="required"
                    field="Name"
                    itemValue="Identifier"
                  ></trans-select2>
                </v-col>
                <v-col
                  xs="12"
                  sm="6"
                  md="4"
                  lg="3"
                  v-if="stores && stores.length > 0"
                >
                  <trans-select2
                    v-model="item.ConfigurationParameter.Identity"
                    propertyName="Store"
                    :items="stores"
                    :label="$t('headers.members_management.Store')"
                    :rules="[$rules.required]"
                    class="required"
                    field="Name"
                    itemValue="Identifier"
                  ></trans-select2>
                </v-col>
                <v-col xs="12" sm="6" md="4" lg="3">
                  <currency-textfield
                    v-if="
                      item.ConfigurationParameter.ParameterType === 'Amount'
                    "
                    :value="item.ConfigurationParameterValue.Value"
                    @change="item.ConfigurationParameterValue.Value = $event"
                    :label="$t('globals.value')"
                    class="required"
                    :rules="[$rules.requiredNum]"
                  />
                  <!-- <no-autocomplete-textfield
                    v-if="
                      item.ConfigurationParameter.ParameterType === 'Amount'
                    "
                    :value="item.ConfigurationParameterValue.Value"
                    @change="item.ConfigurationParameterValue.Value = $event"
                    :label="$t('globals.value')"
                    :rules="[$rules.required]"
                    class="required"
                    prefix="$"
                    @keydown="currencyKeydown"
                    @keyup="currencyKeyUp"
                    @blur="amountBlur"
                  ></no-autocomplete-textfield> -->
                  <currency-textfield
                    v-else-if="
                      item.ConfigurationParameter.ParameterType === 'Percentage'
                    "
                    :value="item.ConfigurationParameterValue.Value"
                    @change="item.ConfigurationParameterValue.Value = $event"
                    :label="$t('globals.value')"
                    class="required"
                    :rules="[$rules.requiredNum, $rules.dynamic.maxValue(100)]"
                    prefix="%"
                  />
                  <!-- <no-autocomplete-textfield
                    v-else-if="
                      item.ConfigurationParameter.ParameterType === 'Percentage'
                    "
                    :value="item.ConfigurationParameterValue.Value"
                    @change="item.ConfigurationParameterValue.Value = $event"
                    :label="$t('globals.value')"
                    :rules="[$rules.required]"
                    class="required"
                    prefix="%"
                    @keydown="currencyKeydown"
                    @keyup="currencyKeyUp"
                  ></no-autocomplete-textfield> -->
                  <no-autocomplete-textfield
                    v-else
                    :value="item.ConfigurationParameterValue.Value"
                    @change="item.ConfigurationParameterValue.Value = $event"
                    :label="$t('globals.value')"
                    :rules="[$rules.required]"
                    class="required"
                  ></no-autocomplete-textfield>
                </v-col>
                <v-col xs="12" sm="6" md="4" lg="3" v-if="employersVisible">
                  <currency-textfield
                    :value="item.ConfigurationParameterValue.FundedPercentage"
                    @change="
                      item.ConfigurationParameterValue.FundedPercentage = $event
                    "
                    :label="$t('views.coverage.funded_percentage')"
                    class="required"
                    :rules="[$rules.requiredNum, $rules.dynamic.maxValue(100)]"
                    prefix="%"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="closeCoverageParameter">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn
            :disabled="!valid"
            color="primary"
            @click="saveCoverageParameter"
          >
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog v-model="dialogs.delete" scrollable persistent max-width="400">
      <material-card
        :title="$t('components.plancreationwizard.remove_coverage_parameter')"
        :color="$vuetify.theme.themes.light.error"
        icon="remove"
      >
        <v-card-text>
          {{ $t("globals.are_you_sure") }}
        </v-card-text>
        <v-card-actions>
          <v-btn color text @click="dialogs.delete = false">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn color="error" text @click="removeCoverageParameter">
            {{ $t("globals.remove") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog scrollable v-model="dialogs.import" persistent max-width="1000px">
      <coverage-parameters-import-wizard
        v-if="dialogs.import"
        :coverage="coverage"
        :formulaTypes="formulaTypes"
        :contributionCategories="contributionCategories"
        :employers="employers"
        @close="dialogs.import = false"
        @parameters="importParameters"
      />
    </v-dialog>
    <pbas-data-table
      :showSelect="false"
      ref="table"
      :dataProvider="provider"
      :rowActions="rowActions"
      :floatActions="floatActions"
      fileNamePrefix="coverageParameters"
      identifier="table"
      @error="error = $event"
    ></pbas-data-table>
    <error-handler :error="error"></error-handler>
  </material-card>
</template>

<script>
import { mapGetters } from "vuex";
import { InMemoryProvider } from "pbas-vue-components";
import BuilderCoverageParametersHeaders from "@/headers/BuilderCoverageParameters";
import ErrorHandler from "@/components/ErrorHandler";
import TransTextbox from "@/components/TransTextbox";
import NoAutocompleteTextfield from "@/components/NoAutocompleteTextfield";
import AutoSelect from "@/components/AutoSelect";
import TransSelect2 from "@/components/TransSelect2";
import { translate2 } from "@/trans2";
import CurrencyTextfield from "@/components/CurrencyTextfield.vue";
import TransEnum from "@/components/TransEnum.vue";
import ApiService from "@/services/api.service";
import CoverageParametersImportWizard from "@/components/PlanBuilder/CoverageParametersImportWizard.vue";
export default {
  components: {
    ErrorHandler,
    TransTextbox,
    NoAutocompleteTextfield,
    AutoSelect,
    TransSelect2,
    CurrencyTextfield,
    CoverageParametersImportWizard,
    TransEnum,
  },
  props: [
    "coverageParameters",
    "planIdentityId",
    "coverage",
    "operatingFeesPerTerm",
    "adminFeesPerTerm",
    "disabled",
    "contributionCategories",
    "employers",
    "planType",
    "calculationEntitiesFormulaTypes",
  ],
  data() {
    return {
      adminFeeOnCoverage: false,
      systemTypes: [
        { Id: "System.Double", Name: "Decimal" },
        { Id: "System.Int32", Name: "Integer" },
      ],
      rules: {
        uniqueParameterName: (v) => {
          let existing = this.provider.items.filter(
            (o) => o.ConfigurationParameter.Name === v
          );
          let valid = true;
          if (existing.length === 0) {
            return true;
          }
          if (
            this.item.ConfigurationParameter.Id !== null &&
            this.item.ConfigurationParameter.Id !== undefined
          ) {
            valid =
              existing.filter(
                (o) =>
                  o.ConfigurationParameter.Id ===
                  this.item.ConfigurationParameter.Id
              ).length === 1;
          } else {
            valid =
              existing.filter((o) => o.Identifier === this.item.Identifier)
                .length === 1;
          }
          return valid || this.$t("validation.name_must_be_unique");
        },
      },
      error: null,
      valid: false,
      dialogs: {
        edit: false,
        delete: false,
        import: false,
      },
      item: null,
      isNew: false,
      floatActions: [
        {
          name: "addCoverageParameter",
          icon: "add",
          color: this.$vuetify.theme.themes.light.success,
          text: "globals.add_new",
          handler: () => {
            this.item = {
              ConfigurationParameterValue: {},
              ConfigurationParameter: {
                Identity: {},
              },
              Identifier: Math.random().toString(),
            };
            this.isNew = true;
            this.dialogs.edit = true;
          },
          visible: () => !this.disabled,
        },
        {
          text: "globals.bulk_import",
          color: this.$vuetify.theme.themes.light.primary,
          name: "import",
          icon: "add",
          handler: () => {
            this.dialogs.import = true;
          },
          visible: () => !this.disabled,
        },
      ],
      rowActions: [
        {
          name: "editCoverageParameter",
          icon: "edit",
          title: "globals.edit",
          handler: (item) => {
            this.item = JSON.parse(JSON.stringify(item));
            if (
              this.item.ConfigurationParameter.CoverageIdentity !== null &&
              this.item.ConfigurationParameter.CoverageIdentity !== undefined
            ) {
              if (this.item.ConfigurationParameter.UsedInFormulaType === 'AdminFee') {
                this.adminFeeOnCoverage = true;
              }
              this.item.ConfigurationParameter.Coverage = this.coverage.filter(
                (o) =>
                  o.Identifier ===
                  this.item.ConfigurationParameter.CoverageIdentity.Identifier
              )[0];
              console.log("edit action: ", JSON.stringify(this.item.ConfigurationParameter), this.item.ConfigurationParameter.Coverage)
            }
            if (this.item.ConfigurationParameter.ParameterType === "Percentage")
              this.item.ConfigurationParameterValue.Value = (
                this.item.ConfigurationParameterValue.Value * 100
              ).toFixed(2);

            if (
              this.item.ConfigurationParameterValue.FundedPercentage !== null &&
              this.item.ConfigurationParameterValue.FundedPercentage !==
                undefined
            )
              this.item.ConfigurationParameterValue.FundedPercentage = (
                this.item.ConfigurationParameterValue.FundedPercentage * 100
              ).toFixed(2);
            this.isNew = false;
            this.dialogs.edit = true;
          },
          visible: () => !this.disabled,
        },
        {
          name: "removeCoverageParameter",
          icon: "delete",
          title: "globals.remove",
          handler: (item) => {
            this.item = JSON.parse(JSON.stringify(item));
            this.dialogs.delete = true;
          },
          visible: () => !this.disabled,
        },
      ],
      provider: undefined,
      headers: BuilderCoverageParametersHeaders,
      stores: [],
      selectableFamilyStatuses: [],
    };
  },
  computed: {
    ...mapGetters("common", ["language"]),
    ...mapGetters("plansMembers", ["options"]),
    coverageParameterFormTitle() {
      return this.isNew
        ? "components.plancreationwizard.create_new_coverage_parameter"
        : "components.plancreationwizard.edit_coverage_parameter";
    },
    coverageParameterFormIcon() {
      return this.isNew ? "add" : "edit";
    },
    formColor() {
      return this.isNew
        ? this.$vuetify.theme.themes.light.success
        : this.$vuetify.theme.themes.light.primary;
    },
    coverageVisible() {
      return (
        this.item &&
        this.item.ConfigurationParameter.UsedInFormulaType &&
        this.item.ConfigurationParameter.UsedInFormulaType !==
          "EmployerContribution" &&
          this.item.ConfigurationParameter.UsedInFormulaType !==
            "Contribution" &&
          this.item.ConfigurationParameter.UsedInFormulaType !==
            "PensionAccruedBenefit" &&
          (this.item.ConfigurationParameter.UsedInFormulaType !==
            "OperatingFee" ||
            !this.operatingFeesPerTerm) &&
            this.item.ConfigurationParameter.UsedInFormulaType.indexOf("Plan") ===-1 &&
          this.item.ConfigurationParameter.UsedInFormulaType !==
            "AdminFee" &&
          this.item.ConfigurationParameter.UsedInFormulaType !==
            "FlatCommission"
      );
    },
    contributionCategoriesVisible() {
      return (
        this.item &&
        this.item.ConfigurationParameter.UsedInFormulaType &&
        this.item.ConfigurationParameter.UsedInFormulaType ===
          "EmployerContribution"
      );
    },
    employersVisible() {
      return (
        this.item &&
        this.item.ConfigurationParameter.UsedInFormulaType &&
        this.item.ConfigurationParameter.UsedInFormulaType ===
          "PensionAccruedBenefit"
      );
    },
    formulaTypes() {
      if (this.planType === "Pension") {
        return this.options.Enums.CalculationFormulaType.filter(
          (o) =>
            o === "EmployerContribution" ||
            o === "Contribution" ||
            o === "PensionAccruedBenefit"
        );
      }
      return this.options.Enums.CalculationFormulaType;
    },
  },
  watch: {
    coverageParameters: {
      handler(v) {
        if (this.provider !== null && this.provider !== undefined) {
          console.log(v);
          this.provider.items = v;
          this.$refs.table.getDataAsync();
        } else {
          this.provider = new InMemoryProvider(v, this.headers);
        }
      },
    },
    "item.ConfigurationParameter.ParameterType": {
      handler(v) {
        if (v && v !== "Constant") {
          this.item.ConfigurationParameter.Type = "System.Double";
        }
      },
      immediate: true,
    },
    // coverageVisible: {
    //   handler(v) {
    //     if (!v && this.item !== null && this.item !== undefined) {
    //       delete this.item.ConfigurationParameter.Coverage;
    //     }
    //   },
    // },
    contributionCategoriesVisible: {
      handler(v) {
        if (!v && this.item !== null && this.item !== undefined) {
          delete this.item.ConfigurationParameter.ContributionCategory;
        }
        // console.log(this.contributionCategories);
        // this.item &&
        //   this.item.ConfigurationParameter &&
        //   console.log(this.item.ConfigurationParameter.ContributionCategory);
      },
    },
    employersVisible: {
      handler(v) {
        if (!v && this.item !== null && this.item !== undefined) {
          delete this.item.ConfigurationParameter.Identity.Employer;
          delete this.item.ConfigurationParameter.Identity.Store;
          delete this.item.ConfigurationParameterValue.FundedPercentage;
        }
        // console.log(this.contributionCategories);
        // this.item &&
        //   this.item.ConfigurationParameter &&
        //   console.log(this.item.ConfigurationParameter.ContributionCategory);
      },
    },
    coverage: {
      handler(v) {
        console.log("coverage is : ", JSON.stringify(v));
        if (v === null || v === undefined) {
          if (this.provider !== null && this.provider !== undefined) {
            for (let cp of this.provider.items) {
              delete cp.ConfigurationParameter.Coverage;
              delete cp.ConfigurationParameter.CoverageIdentity;
            }
          }
        } else {
          if (this.provider !== null && this.provider !== undefined) {
            for (let cp of this.provider.items) {
              // console.log(cp);
              if (
                cp.ConfigurationParameter.Coverage !== null &&
                cp.ConfigurationParameter.Coverage !== undefined
              ) {
                if (
                  v.filter(
                    (o) =>
                      o.Identifier ===
                      cp.ConfigurationParameter.Coverage.Identifier
                  ).length === 0
                ) {
                  delete cp.ConfigurationParameter.Coverage;
                }
              } else if (
                cp.ConfigurationParameter.CoverageIdentity !== null &&
                cp.ConfigurationParameter.CoverageIdentity !== undefined
              ) {
                if (
                  v.filter(
                    (o) =>
                      o.Identifier ===
                      cp.ConfigurationParameter.CoverageIdentity.Identifier
                  ).length === 0
                ) {
                  delete cp.ConfigurationParameter.CoverageIdentity;
                }
              }
            }
          }
        }
      },
      deep: true,
      immediate: true,
    },
    "item.ConfigurationParameter.Identity.Employer": {
      async handler(v) {
        if (v) {
          console.log("@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@", v);
          // if (this.planParameters.HasStores) {
          if (v.Stores) {
            const collator = new Intl.Collator(undefined, {
              numeric: true,
              sensitivity: "base",
            });
            this.stores = v.Stores /*.filter(
                (o) => o.IsAssignable !== false
              )*/.sort(collator.compare);
          }
          if (
            !v.Stores /*||
              v.Stores.filter((o) =>
                this.item.ConfigurationParameter.Store
                  ? o.Identifier === this.item.ConfigurationParameter.Store.Identifier
                  : false
              ).length === 0*/
          ) {
            this.item.ConfigurationParameter.Store = null;
            this.stores = [];
          }
        }
        console.log("@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@", this.stores);
        // } else {
        //   this.stores = [];
        // }
      },
    },
  },
  async mounted() {
    if (
      this.coverageParameters !== null &&
      this.coverageParameters !== undefined
    ) {
      this.provider = new InMemoryProvider(
        this.coverageParameters,
        this.headers
      );
    }
  },
  methods: {
    importParameters(parameters) {
      const formattedParameters = parameters.map((o) => {
        return this.saveCoverageParameter(o, true);
      });
      this.provider.items = formattedParameters;
      this.$refs.table.getDataAsync();
      this.dialogs.import = false;
      this.$emit("update-coverage-parameters", this.provider.items);
    },
    async getSelectableFamilyStatus(id) {
      try {
        let res = await ApiService.get("/settings/familyStatusHierarchy");
        //console.log(res.data);
        this.selectableFamilyStatuses = res.data[id];
      } catch (error) {
        this.error = error;
      }
    },
    setCalculationEntity(calculationFormulaType) {
      if (calculationFormulaType) {
        this.item.ConfigurationParameter.CalculationEntity =
          this.calculationEntitiesFormulaTypes[calculationFormulaType];
      }
    },
    trans(item, str) {
      return translate2(item, str);
    },
    truncate(str, n, useWordBoundary) {
      if (str.length <= n) {
        return str;
      }
      const subString = str.substr(0, n - 1); // the original check
      return (
        (useWordBoundary
          ? subString.substr(0, subString.lastIndexOf(" "))
          : subString) + "..."
      );
    },
    filteredCoverage() {
      const coverage = this.coverage.filter((o) => !o.IsFreeOfCharge);
      switch (this.item.ConfigurationParameter.UsedInFormulaType) {
        case "Premium": {
          return coverage.filter(
            (o) =>
              o.PlanInsuranceCarrier !== null &&
              o.PlanInsuranceCarrier !== undefined
          );
        }
        case "PremiumVolume": {
          return coverage.filter(
            (o) =>
              o.PlanInsuranceCarrier !== null &&
              o.PlanInsuranceCarrier !== undefined &&
              o.HasVolume
          );
        }
        case "Remittance": {
          return coverage.filter(
            (o) => o.TrustFund !== null && o.TrustFund !== undefined
          );
        }
        case "RemittanceVolume": {
          return coverage.filter(
            (o) =>
              o.TrustFund !== null && o.TrustFund !== undefined && o.HasVolume
          );
        }
        case "AdminFee": {
          return coverage.filter((o) => o.HasAdminFees);
        }
        case "TaxableBenefitProvincial": {
          return coverage.filter((o) => o.IsTaxableBenefit);
        }
        case "TaxableBenefitFederal": {
          return coverage.filter((o) => o.IsTaxableBenefit);
        }
        case "TaxableBenefitProvincialTax": {
          return coverage.filter((o) => o.IsTaxableBenefit);
        }
        case "TaxableBenefitFederalTax": {
          return coverage.filter((o) => o.IsTaxableBenefit);
        }
        case "Contribution": {
          return coverage.filter((o) => o.IncludedInEmployerContribution);
        }
        case "Commission": {
          return coverage.filter((o) => o.HasCommissions);
        }
        case "PPTTax": {
          return coverage.filter((o) => o.IncludePPT);
        }
        case "RSTTax": {
          return coverage.filter((o) => o.IncludeRST);
        }
        case "HSTTax": {
          return coverage.filter((o) => o.IncludeHST);
        }
        case "PSTTax": {
          return coverage.filter((o) => o.IncludePST);
        }
        case "GSTTax": {
          return coverage.filter((o) => o.IncludeGST);
        }
        case "PPTAdminTax": {
          return coverage.filter((o) => o.IncludeAdminPPT);
        }
        case "RSTAdminTax": {
          return coverage.filter((o) => o.IncludeAdminRST);
        }
        case "HSTAdminTax": {
          return coverage.filter((o) => o.IncludeAdminHST);
        }
        case "PSTAdminTax": {
          return coverage.filter((o) => o.IncludeAdminPST);
        }
        case "GSTAdminTax": {
          return coverage.filter((o) => o.IncludeAdminGST);
        }
        case "PPTOperatingTax": {
          return coverage.filter((o) => o.IncludeOperatingPPT);
        }
        case "RSTOperatingTax": {
          return coverage.filter((o) => o.IncludeOperatingRST);
        }
        case "HSTOperatingTax": {
          return coverage.filter((o) => o.IncludeOperatingHST);
        }
        case "PSTOperatingTax": {
          return coverage.filter((o) => o.IncludeOperatingPST);
        }
        case "GSTOperatingTax": {
          return coverage.filter((o) => o.IncludeOperatingGST);
        }
        case "OperatingFee": {
          return coverage.filter((o) => o.HasOperatingFees);
        }
        case "QSTTax": {
          return coverage.filter((o) => o.IncludeQST);
        }
        case "QSTAdminTax": {
          return coverage.filter((o) => o.IncludeAdminQST);
        }
        case "QSTOperatingTax": {
          return coverage.filter((o) => o.IncludeOperatingQST);
        }
        case "EmployerContribution": {
          return coverage.filter((o) => o.IncludedInEmployerContribution);
        }
        // case "PensionAccruedBenefit": {
        //   return coverage.filter(o=>o.IncludedInEmployerContribution);
        // }
        case "PPTCommissionTax": {
          return coverage.filter((o) => o.IncludeCommissionPPT);
        }
        case "RSTCommissionTax": {
          return coverage.filter((o) => o.IncludeCommissionRST);
        }
        case "HSTCommissionTax": {
          return coverage.filter((o) => o.IncludeCommissionHST);
        }
        case "PSTCommissionTax": {
          return coverage.filter((o) => o.IncludeCommissionPST);
        }
        case "GSTCommissionTax": {
          return coverage.filter((o) => o.IncludeCommissionGST);
        }
        case "QSTCommissionTax": {
          return coverage.filter((o) => o.IncludeCommissionQST);
        }
        case "ClaimCommission": {
          return coverage.filter((o) => o.IncludeClaimCommission);
        }
        case "ClaimCommissionPPTTax": {
          return coverage.filter((o) => o.IncludeClaimCommissionPPTTax);
        }
        case "ClaimCommissionRSTTax": {
          return coverage.filter((o) => o.IncludeClaimCommissionRSTTax);
        }
        case "ClaimCommissionHSTTax": {
          return coverage.filter((o) => o.IncludeClaimCommissionHSTTax);
        }
        case "ClaimCommissionPSTTax": {
          return coverage.filter((o) => o.IncludeClaimCommissionPSTTax);
        }
        case "ClaimCommissionGSTTax": {
          return coverage.filter((o) => o.IncludeClaimCommissionGSTTax);
        }
        case "ClaimCommissionQSTTax": {
          return coverage.filter((o) => o.IncludeClaimCommissionQSTTax);
        }
        case "FlatCommission": {
          return coverage.filter((o) => o.IncludeFlatCommission);
        }
        case "FlatPPTCommissionTax": {
          return coverage.filter((o) => o.IncludeFlatPPTCommissionTax);
        }
        case "FlatRSTCommissionTax": {
          return coverage.filter((o) => o.IncludeFlatRSTCommissionTax);
        }
        case "FlatHSTCommissionTax": {
          return coverage.filter((o) => o.IncludeFlatHSTCommissionTax);
        }
        case "FlatPSTCommissionTax": {
          return coverage.filter((o) => o.IncludeFlatPSTCommissionTax);
        }
        case "FlatGSTCommissionTax": {
          return coverage.filter((o) => o.IncludeFlatGSTCommissionTax);
        }
        case "FlatQSTCommissionTax": {
          return coverage.filter((o) => o.IncludeFlatQSTCommissionTax);
        }
        case "ClaimAdminFee": {
          return coverage.filter((o) => o.IncludeClaimAdminFee);
        }
        case "ClaimPPTAdminTax": {
          return coverage.filter((o) => o.IncludeClaimPPTAdminTax);
        }
        case "ClaimRSTAdminTax": {
          return coverage.filter((o) => o.IncludeClaimRSTAdminTax);
        }
        case "ClaimHSTAdminTax": {
          return coverage.filter((o) => o.IncludeClaimHSTAdminTax);
        }
        case "ClaimPSTAdminTax": {
          return coverage.filter((o) => o.IncludeClaimPSTAdminTax);
        }
        case "ClaimGSTAdminTax": {
          return coverage.filter((o) => o.IncludeClaimGSTAdminTax);
        }
        case "ClaimQSTAdminTax": {
          return coverage.filter((o) => o.IncludeClaimQSTAdminTax);
        }
        default:
          return coverage;
      }
    },
    saveCoverageParameter(itemFromBulkImport, isBulkImport) {
      if (isBulkImport) {
        this.item = itemFromBulkImport;
      }
      this.setCalculationEntity(
        this.item.ConfigurationParameter.UsedInFormulaType
      );
      let item = JSON.parse(JSON.stringify(this.item));
      console.log("save parameter: ", JSON.stringify(this.item));
      if (this.item.ConfigurationParameter.UsedInFormulaType === 'AdminFee') {
        if (!this.adminFeeOnCoverage) {
          delete item.ConfigurationParameter.Coverage;
          delete item.ConfigurationParameter.CoverageIdentity;
        }
      } else if (!this.coverageVisible) {
        delete item.ConfigurationParameter.Coverage;
        delete item.ConfigurationParameter.CoverageIdentity;
      }

      if (
        item.ConfigurationParameter.Coverage !== null &&
        item.ConfigurationParameter.Coverage !== undefined
      ) {
        console.log("param #1");
        if (
          item.ConfigurationParameter.CoverageIdentity === null ||
          item.ConfigurationParameter.CoverageIdentity === undefined
        ) {
          item.ConfigurationParameter.CoverageIdentity = {
            Current: {},
            // Identifier: item.ConfigurationParameter.Coverage.Identifier,
          };
        }
        item.ConfigurationParameter.CoverageIdentity.Current.Name =
          item.ConfigurationParameter.Coverage.Name;
        item.ConfigurationParameter.CoverageIdentity.Current.Translations =
          item.ConfigurationParameter.Coverage.Translations;
        item.ConfigurationParameter.CoverageIdentity.Identifier =
          item.ConfigurationParameter.Coverage.Identifier;
        delete item.ConfigurationParameter.Coverage;
      } else {
        console.log("param #2", this.planIdentityId);
        item.ConfigurationParameter.PlanIdentityId = this.planIdentityId;
      }
      item.ConfigurationParameter.Name =
        this.item.ConfigurationParameter.Translations.filter(
          (o) => o.LanguageCode === this.language.language
        )[0].Name;

      item.ConfigurationParameter.Description =
        item.ConfigurationParameter.Name;
      item.ConfigurationParameter.SystemName = this.convertToCamelCase(
        item.ConfigurationParameter.Name
      );
      item.ConfigurationParameterValue.SystemType =
        item.ConfigurationParameter.Type;

      if (item.ConfigurationParameter.ParameterType === "Percentage")
        item.ConfigurationParameterValue.Value = (
          item.ConfigurationParameterValue.Value / 100
        ).toFixed(4);

      if (
        item.ConfigurationParameterValue.FundedPercentage !== null &&
        item.ConfigurationParameterValue.FundedPercentage !== undefined
      )
        item.ConfigurationParameterValue.FundedPercentage = (
          item.ConfigurationParameterValue.FundedPercentage / 100
        ).toFixed(4);
      if (!isBulkImport) {
        if (this.isNew) {
          this.addCoverageParameter(item);
        } else {
          this.updateCoverageParameter(item);
        }
      } else {
        return item;
      }
    },
    convertToCamelCase(input) {
      return this.toCamelCase(this.toWords(input));
    },
    toWords(input) {
      var regex =
        /[A-Z\xC0-\xD6\xD8-\xDE]?[a-z\xDF-\xF6\xF8-\xFF]+|[A-Z\xC0-\xD6\xD8-\xDE]+(?![a-z\xDF-\xF6\xF8-\xFF])|\d+/g;

      return input.match(regex);
    },
    toCamelCase(inputArray) {
      let result = "";

      for (let i = 0, len = inputArray.length; i < len; i++) {
        let currentStr = inputArray[i];

        let tempStr = currentStr.toLowerCase();

        if (i != 0) {
          // convert first letter to upper case (the word is in lowercase)
          tempStr = tempStr.substr(0, 1).toUpperCase() + tempStr.substr(1);
        }

        result += tempStr;
      }

      return result;
    },
    updateCoverageParameter(item) {
      let coverageParameter;
      coverageParameter = this.provider.items.filter(
        (o) => o.Identifier === item.Identifier
      )[0];
      let index = this.provider.items.indexOf(coverageParameter);
      this.provider.items[index] = item;
      console.log(
        "param #3",
        JSON.stringify(
          this.provider.items[index]
        )
      );
      this.closeCoverageParameter();
      this.$refs.table.getDataAsync();
      this.$emit("update-coverage-parameters", this.provider.items);
    },
    addCoverageParameter(item) {
      this.provider.items.push(item);
      this.closeCoverageParameter();
      this.$refs.table.getDataAsync();
      this.$emit("update-coverage-parameters", this.provider.items);
    },
    removeCoverageParameter() {
      let item = JSON.parse(JSON.stringify(this.item));
      let coverageParameter;
      coverageParameter = this.provider.items.filter(
        (o) => o.Identifier === item.Identifier
      )[0];
      this.provider.items.splice(
        this.provider.items.indexOf(coverageParameter),
        1
      );
      this.closeCoverageParameter();
      this.$refs.table.getDataAsync();
    },
    closeCoverageParameter() {
      this.dialogs.edit = false;
      this.dialogs.delete = false;
      this.item = null;
      if (this.$refs.form) this.$refs.form.resetValidation();
    },
  },
};
</script>

<style></style>
